/*
   This element gives ability to pre-fill catalog part number instead of configuring
 */

import React from 'react'
import store from "../store/store";
import { useSelector, useDispatch } from "react-redux";
import {updateCatalogLookup} from "../store/configuratorStateSlice";
import {runPartNumberLookup} from "../store/product/productDataSlice";

const IKnowMyPartNumber = (props) => {

    const dispatch = useDispatch();
    const partNumber = useSelector(state => state.configuratorStateReducer.catalogNumberLookup);


    const handleClick = (e) => {
        e.preventDefault();
        // if there are any notices, this will clear them
        store.dispatch({type: 'CLEAR_NOTICES'});
        store.dispatch({type: 'RESET_SELECTIONS'});
        store.dispatch({type: 'UPDATE_IS_PATTERN', value: false});
        if(partNumber) {
            store.dispatch(runPartNumberLookup());
            store.dispatch({type: 'SET_ERRORS', value: false})
            addDashToPortal(partNumber);
            // We want to scroll down so that user see that form is pre-filled
            setTimeout(function(){
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#summary-panel") ? $("#summary-panel").offset().top: ""
                }, 500);
            }, 750);

        } else {
            store.dispatch({type: 'SET_ERRORS', value: true})
        }
    }

    // Customers can usually enter catalog numbers without dashes due to external system requirements.
    // Portal require dashes they are automatically added between the 3rd and 4th character
    const addDashToPortal = (partNumber) => {

        const regex = /(^TC.)/;
        if(regex.test(partNumber) && partNumber[3] != "-") {
            const cleanedPartNumber = partNumber.slice(0,3) + "-" + partNumber.slice(3);
            dispatch(updateCatalogLookup(cleanedPartNumber));
        }
    }

    const handleOnChange = (event) => {
        dispatch(updateCatalogLookup(event.target.value))
    }

    const handleKeypress = (event) => {
        if(event.key === 'Enter'){
            event.preventDefault();
            handleClick(event);
        }

    }

    
    return (
        <div className="row setup-steps" id="part_number">
            <div className="small-2 columns">
                <label>
                    Catalog # Lookup
                </label>
            </div>
            <div className="small-8 columns end part-number-lookup">
                <input id="part-number-field" value={partNumber} style={{'marginLeft': 0}}
                       onChange={(e) => handleOnChange(e)}
                       onKeyPress={(e) => handleKeypress(e)}
                       type="text" />
                    <button name="step_action" type="submit" value="configure_from_catalog_number"
                            id="catalog_number_button" className="add-quote button"
                            onClick={handleClick}>GO
                    </button>
            </div>
        </div>
    )
}

export default  IKnowMyPartNumber;